export default {
   tmpContentBackgroundColor: '#f5f4eb',
   tmpContentLineColor: 'rgba(0,0,0,0.4)',
   tmpViewportPadding: '20px[a] 20px[b] 40px[c] 30px[d] 4vw[e] calc(50vw - 850px + 150px)[f]',
   tmpViewportPaddingE: '4vw',
   tmpViewportPaddingF: 'calc(50vw - 850px + 150px)'
}
